import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/auth/Login";
import ProtectedRoute from "./components/common/ProtectedRoute";
import AdminDashboardPage from "./pages/DashboardPage";
import VisitPlanningPage from "./pages/VisitPlanningPage";
import DoctorDatabasePage from "./pages/DoctorDatabasePage";
import EmployeesPage from "./pages/EmployeesPage";
import ExpensesPage from "./pages/ExpensesPage";
import HRLeavePage from "./pages/HRLeavePage";
import HolidaysPage from "./pages/HolidaysPage";
import MasterPage from "./pages/MasterPage";
import AllowanceSettingsPage from "./pages/AllowanceSettingsPage";
import DesignationPage from "./pages/master/DesignationPage";
import CountryPage from "./pages/master/CountryPage";
import ZonePage from "./pages/master/ZonePage";
import HeadQuarterPage from "./pages/master/HeadQuarterPage";
import LocationPage from "./pages/master/LocationPage";
import EmployeePage from "./pages/master/EmployeePage";
import { useAuth } from "./context/AuthContext";
import { paths } from "./routes/path";
import DoctorMasterPage from "./pages/master/DoctorMasterPage";
import MedicineMasterPage from "./pages/master/MedicineMasterPage";
import SfcPage from "./pages/master/SfcPage";
import RouteMasterPage from "./pages/master/RouteMasterPage";
import DailyAllowanceMasterPage from "./pages/master/DailyAllowanceMasterPage";
import FirmPage from "./pages/FirmPage";
import TourPlansPage from "./pages/TourPlansPage";
import AttendancePage from "./pages/AttendancePage";
import DeviceManagementPage from "./pages/DeviceManagementPage";
import SettingsPage from "./pages/SettingsPage";
import CallReportsPage from "./pages/reports/CallReportsPage";
import MissedCallsPage from "./pages/reports/MissedCallsPage";
import VisitTrackerPage from "./pages/reports/VisitTrackerPage";

function App() {

  const { logout } = useAuth();

  const handleLogout = () => {
    logout()
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path={`${paths.login}`} element={<Login />} />

        <Route
          path={`${paths.dashboard}`}
          element={
            <ProtectedRoute>
              <AdminDashboardPage
                onLogout={handleLogout}
                currentPage="dashboard"
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.visitPlanning}`}
          element={
            <ProtectedRoute>
              <VisitPlanningPage
                onLogout={handleLogout}
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.doctors}`}
          element={
            <ProtectedRoute>
              <DoctorDatabasePage
                onLogout={handleLogout}
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.firms}`}
          element={
            <ProtectedRoute>
              <FirmPage
                onLogout={handleLogout}
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.employees}`}
          element={
            <ProtectedRoute>
              <EmployeesPage
                onLogout={handleLogout}
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.holidays}`}
          element={
            <ProtectedRoute>
              <HolidaysPage
                onLogout={handleLogout}
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.tourPlan}`}
          element={
            <ProtectedRoute>
              <TourPlansPage
                onLogout={handleLogout}
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />


        <Route
          path={`${paths.expenses}`}
          element={
            <ProtectedRoute>
              <ExpensesPage
                onLogout={handleLogout}
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.allowanceSettings}`}
          element={
            <ProtectedRoute>
              <AllowanceSettingsPage
                onLogout={handleLogout}
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.hrLeave}`}
          element={
            <ProtectedRoute>
              <HRLeavePage
                onLogout={handleLogout}
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        {/* <Route
          path={`${paths.employee}`}
          element={
            <ProtectedRoute>
              <EmployeePage
                onLogout={handleLogout}
                currentPage="employee"
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        /> */}

        {/* <Route
          path={`${paths.master}`}
          element={
            <ProtectedRoute>
              <MasterPage
                onLogout={handleLogout}
                currentPage="master"
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        /> */}

        <Route
          path={`${paths.designation}`}
          element={
            <ProtectedRoute>
              <DesignationPage
                onLogout={handleLogout}
                currentPage="designation"
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.country}`}
          element={
            <ProtectedRoute>
              <CountryPage
                onLogout={handleLogout}
                currentPage="country"
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.zone}`}
          element={
            <ProtectedRoute>
              <ZonePage
                onLogout={handleLogout}
                currentPage="zone"
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.headquarter}`}
          element={
            <ProtectedRoute>
              <HeadQuarterPage
                onLogout={handleLogout}
                currentPage="headquarter"
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.location}`}
          element={
            <ProtectedRoute>
              <LocationPage
                onLogout={handleLogout}
                currentPage="location"
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.doctorMaster}`}
          element={
            <ProtectedRoute>
              <DoctorMasterPage
                onLogout={handleLogout}
                currentPage="doctor-master"
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.medicineMaster}`}
          element={
            <ProtectedRoute>
              <MedicineMasterPage
                onLogout={handleLogout}
                currentPage="medicine-master"
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.sfc}`}
          element={
            <ProtectedRoute>
              <SfcPage
                onLogout={handleLogout}
                currentPage="sfc"
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.routeMaster}`}
          element={
            <ProtectedRoute>
              <RouteMasterPage
                onLogout={handleLogout}
                currentPage="route-master"
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={`${paths.dailyAllowance}`}
          element={
            <ProtectedRoute>
              <DailyAllowanceMasterPage
                onLogout={handleLogout}
                currentPage="daily-allowance"
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={paths.attendance}
          element={
            <ProtectedRoute>
              <AttendancePage onLogout={handleLogout} onNavigate={(page) => (window.location.href = `/${page}`)} />
            </ProtectedRoute>
          }
        />
        <Route
          path={paths.reportCallReports}
          element={
            <ProtectedRoute>
              <CallReportsPage onLogout={handleLogout} onNavigate={(page) => (window.location.href = `/${page}`)} />
            </ProtectedRoute>
          }
        />
        <Route
          path={paths.reportMissedCalls}
          element={
            <ProtectedRoute>
              <MissedCallsPage onLogout={handleLogout} onNavigate={(page) => (window.location.href = `/${page}`)} />
            </ProtectedRoute>
          }
        />
        <Route
          path={paths.reportVisitTracker}
          element={
            <ProtectedRoute>
              <VisitTrackerPage onLogout={handleLogout} onNavigate={(page) => (window.location.href = `/${page}`)} />
            </ProtectedRoute>
          }
        />

        <Route
          path={paths.deviceManagement}
          element={
            <ProtectedRoute>
              <DeviceManagementPage
                onLogout={handleLogout}
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path={paths.appSettings}
          element={
            <ProtectedRoute>
              <SettingsPage
                onLogout={handleLogout}
                onNavigate={(page) => (window.location.href = `/${page}`)}
              />
            </ProtectedRoute>
          }
        />

        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
